import { compact } from 'lodash';
import { Control, FieldValues } from 'react-hook-form';

import { FormAwareRadioGroup } from '@/components/form/formAwareInputs/FormAwareRadioGroup';
import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';
import { FieldNameFromFormShape } from '@/types/react-hook-form';
import { EmployeeTier, TenantProductTier } from '@/types/schema';

import { EMPLOYEE_TIER_DISPLAY_MAP } from './constants';

interface EmployeeTierSelectorProps<FormShape extends FieldValues> {
  control: Control<FormShape>;
  fieldName: FieldNameFromFormShape<FormShape>;
  label?: string;
  required?: boolean;
}

export function EmployeeTierSelector<FormShape extends FieldValues>({
  control,
  fieldName,
  label = 'Type',
  required = false,
}: EmployeeTierSelectorProps<FormShape>) {
  const { tier: tenantTier } = useTenantDetailsContext();

  return (
    <FormAwareRadioGroup<FormShape>
      control={control}
      fieldName={fieldName}
      label={label}
      required={required}
      columnSpacing={1}
      options={compact([
        {
          value: EmployeeTier.Advanced,
          label: EMPLOYEE_TIER_DISPLAY_MAP[EmployeeTier.Advanced],
          helpText: 'Full access to all features',
        },
        tenantTier !== TenantProductTier.Go && {
          value: EmployeeTier.Basic,
          label: EMPLOYEE_TIER_DISPLAY_MAP[EmployeeTier.Basic],
          helpText: 'Access to all features except for the waterfall',
        },
        {
          value: EmployeeTier.ViewOnly,
          label: EMPLOYEE_TIER_DISPLAY_MAP[EmployeeTier.ViewOnly],
          helpText: 'View-only access to all features, plus document uploads',
        },
      ])}
      row={false}
    />
  );
}
